import { intl } from '@approvalmax/utils';
import moment from 'moment';
import { ReadOnlyCell } from 'pages/requestForm/components';
import { useNetSuiteBillPaymentCreditListFieldSettings } from 'shared/hooks';

import { ColumnDefinition } from '../../../../selectors/types/ColumnDefinition';
import { NetSuiteCreditListLineExpanded } from '../../data/types';
import { isFieldVisible } from '../../NetSuiteRequestForm/NetSuiteRequestForm.helpers';
import { messages } from './NetSuiteCreditList.messages';
import { ExtendedColumnDefinition } from './NetSuiteCreditList.types';

export const getColumnDefs = (
    fieldSettings: ReturnType<typeof useNetSuiteBillPaymentCreditListFieldSettings>,
    currencyPrecision: number
): ColumnDefinition<NetSuiteCreditListLineExpanded>[] => {
    const columnDef: ExtendedColumnDefinition[] = [
        {
            id: 'date-due',
            name: messages.dateDueColumnName,
            readonly: () => true,
            cell: (li) => <ReadOnlyCell text={li.dateDue ? moment.utc(li.dateDue).format('ll') : ''} />,
            isHidden: !isFieldVisible(fieldSettings.dateDue),
        },
        {
            id: 'type',
            name: messages.typeColumnName,
            readonly: () => true,
            cell: (li) => <ReadOnlyCell text={li.type ?? ''} />,
            isHidden: !isFieldVisible(fieldSettings.type),
        },
        {
            id: 'reference',
            name: messages.referenceColumnName,
            readonly: () => true,
            cell: (li) => <ReadOnlyCell text={li.reference ?? ''} />,
            isHidden: !isFieldVisible(fieldSettings.reference),
        },
        {
            id: 'applied-to',
            name: messages.appliedToColumnName,
            readonly: () => true,
            cell: (li) => <ReadOnlyCell text={li.appliedTo ?? ''} />,
            isHidden: !isFieldVisible(fieldSettings.appliedTo),
        },
        {
            id: 'currency',
            name: messages.currencyColumnName,
            readonly: () => true,
            cell: (li) => <ReadOnlyCell text={li.currencyName ?? ''} />,
            isHidden: !isFieldVisible(fieldSettings.currency),
        },
        {
            id: 'payment-amount',
            name: messages.paymentAmountColumnName,
            alignRight: true,
            readonly: () => true,
            cell: (li) => <ReadOnlyCell text={intl.formatNumber(li.paymentAmount, currencyPrecision)} />,
            isHidden: !isFieldVisible(fieldSettings.paymentAmount),
        },
    ];

    return columnDef.filter(({ isHidden }) => !isHidden);
};
